import cx from 'classnames'
import { Skeleton } from '@pogokid/mui'
import { GlassSurface } from '~m/designSystem/components/GlassSurface/GlassSurface'
import progressStyles from './ProgressDetailed.module.css'
import styles from './ProgressDetailedSkeleton.module.css'

export interface ProgressDetailedSkeletonProps {
  /** Number of task card placeholders to render. Defaults to 4. */
  tasks?: number
  /** Additional CSS class. */
  className?: string
}

export function ProgressDetailedSkeleton({
  tasks = 4,
  className,
}: ProgressDetailedSkeletonProps) {
  return (
    <GlassSurface
      component="section"
      variant="panel"
      aria-busy="true"
      aria-live="polite"
      className={cx(progressStyles.ProgressDetailed, className)}
    >
      <header className={styles.ProgressDetailedSkeleton__header}>
        <Skeleton
          variant="text"
          width="60%"
          height={32}
          className={styles.ProgressDetailedSkeleton__title}
        />
        <Skeleton variant="text" width="90%" />
        <Skeleton variant="text" width="75%" />
      </header>

      <div className={styles.ProgressDetailedSkeleton__progressRow}>
        <Skeleton
          variant="rectangular"
          height={4}
          className={styles.ProgressDetailedSkeleton__progressBar}
        />
        <Skeleton
          variant="text"
          width={140}
          className={styles.ProgressDetailedSkeleton__progressLabel}
        />
      </div>

      <ul className={styles.ProgressDetailedSkeleton__tasks}>
        {Array.from({ length: tasks }).map((_, index) => (
          <GlassSurface
            key={index}
            component="li"
            variant="card"
            className={styles.ProgressDetailedSkeleton__task}
          >
            <Skeleton
              variant="rectangular"
              width={44}
              height={44}
              className={
                styles.ProgressDetailedSkeleton__taskIcon
              }
            />
            <Skeleton
              variant="text"
              width="80%"
              height={24}
              className={
                styles.ProgressDetailedSkeleton__taskTitle
              }
            />
            <Skeleton
              variant="text"
              width="100%"
              className={
                styles.ProgressDetailedSkeleton__taskDescription
              }
            />
            <Skeleton variant="text" width="60%" />
          </GlassSurface>
        ))}
      </ul>
    </GlassSurface>
  )
}
